import axios from 'axios'
import { useUserStore } from '@/store'
// import router from '@/router';  // 根据你的项目结构和文件路径进行调整

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const param = config.data;
    let store = useUserStore();
    store.$patch({
      requestCode: 0
    })
    // if (config.access !== false) {
    //   let userStore = useUserStore();
    //   if (userStore.access) {
    //       param['userId'] = userStore.access.userId;
    //       param['accessToken'] = userStore.access.accessToken;
    //   }
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response
    // const currentRoute = router.currentRoute;
    if(res.data.code == 217){
      let userStore = useUserStore();
      userStore.$patch({
        requestCode: 217
      })
      return res;
    }else if(res.data.code == 205){
      let userStore = useUserStore();
      userStore.$patch({
        requestCode: 205
      })
      return res;
    }
    return res
  },
  error => {
    console.log(error)

    return Promise.reject(error)
  }
)

export default service
